import React from 'react'

const BarrierWhiteSvg = ({ width }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      viewBox='0 0 28.286 28.286'
    >
      <path
        id='barrier-svgrepo-com_1_'
        data-name='barrier-svgrepo-com (1)'
        d='M7.429,1A1.286,1.286,0,0,1,8.714,2.286V4.857H21.572V2.286a1.286,1.286,0,1,1,2.571,0V4.857h1.286a3.857,3.857,0,0,1,3.857,3.857v5.143a3.857,3.857,0,0,1-3.857,3.857H24.143V28a1.286,1.286,0,1,1-2.571,0V17.715H8.714V28a1.286,1.286,0,0,1-2.571,0V17.715H4.857A3.857,3.857,0,0,1,1,13.857V8.714A3.857,3.857,0,0,1,4.857,4.857H6.143V2.286A1.286,1.286,0,0,1,7.429,1ZM3.571,8.714A1.286,1.286,0,0,1,4.857,7.429H7.92L4.164,14.94a1.285,1.285,0,0,1-.592-1.083Zm3.366,6.429H9.206l3.857-7.714H10.795Zm9-7.714L12.08,15.143h2.268l3.857-7.714Zm5.143,0-3.857,7.714h2.268l3.857-7.714Zm5.042.2-3.756,7.512h3.063a1.286,1.286,0,0,0,1.286-1.286V8.714A1.285,1.285,0,0,0,26.122,7.631Z'
        transform='translate(-1 -1)'
        fill='#fff'
        fillRule='evenodd'
      />
    </svg>
  )
}

export default BarrierWhiteSvg
